export const professionalStatusList = [
	{
		NAME: 'CUENTA_AJENA',
		VALUE: 'Trabajador por cuenta ajena',
	},
	{
		NAME: 'CUENTA_PROPIA',
		VALUE: 'Empresario, profesional autónomo',
	},
	{
		NAME: 'ESTUDIANTE',
		VALUE: 'Estudiante',
	},
	{
		NAME: 'PARADO',
		VALUE: 'No trabaja, parado',
	},
	{
		NAME: 'OTROS',
		VALUE: 'Otros',
	},
];

export const professionalStatusTypes = professionalStatusList.reduce((acc, item) => {
	acc[item.NAME] = item.VALUE;
	return acc;
}, {});
